import { FixedRateService, Project, SubProject } from '../../../models/interfaces';
import { Box, Paper, Stack, Switch, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Typography, Chip, Tooltip, IconButton, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { calculateProjectCost, calculateResourceCost } from '../project-utils';
import LayersIcon from '@mui/icons-material/Layers'
import dayjs from 'dayjs';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
import { addAssignBusyResourceIds, removeAssignBusyResourceIds } from '../../../slices/assign';
import { retrieveProjectsById } from '../../../slices/projects';
import { removeServerFixedRateService } from '../../../slices/fixedrateservice';
import { RequestQuote } from '@mui/icons-material';


const ODD_OPACITY = 0.2;
const tableStyles = {
    stickyFooter: {
        position: 'sticky',
        bottom: 0,
        backgroundColor: 'background.paper',
        borderTop: '2px solid #e0e0e0',
    } as React.CSSProperties,
    cellMaterial: {
        '&:hover': {
            backgroundColor: 'lightgray', // Change background color on hover
        },
    } as React.CSSProperties,
};

export const ProjectSummaryFixedRateServiceTableRow = (props: { project: Project, sub_project: SubProject, sub_project_colors: Record<string, string>, fixedrateservice: FixedRateService, remove: boolean }) => {
    const dispatch = useDispatch<AppDispatch>();
    const [is_busy, setIsBusy] = useState(false);

    const handleUnassignFromProject = (fixedrateservice: FixedRateService) => {
        setIsBusy(true);
        const updated_fixedrateservice = {
            ...props.fixedrateservice,
        }
        dispatch(addAssignBusyResourceIds([updated_fixedrateservice.id]));
        dispatch(removeServerFixedRateService({ fixed_rate_service: updated_fixedrateservice })).then((result) => {
            if (result.type === 'fixed_rate_services/remove_server_fixed_rate_service/fulfilled') {
                console.log('fixedrateservice deleted');
                const project = props.project;
                if (project?.id) {
                    dispatch(retrieveProjectsById({ ids: [project?.id] }));
                }
            } else {
                console.log('fixedrateservice delete failed')
            }
            setIsBusy(false);
        })
    }

    const handleCellContextMenu = (e: React.MouseEvent<HTMLTableCellElement, MouseEvent>, text: string) => {
        e.stopPropagation();
        e.preventDefault();
        if (text) {
            navigator.clipboard.writeText(text);
        }
    }

    return (
        <TableRow key={`${props.sub_project.id}-${props.fixedrateservice.id}`} hover>
            <TableCell onContextMenu={(e) => handleCellContextMenu(e, `${props.fixedrateservice.id}`)}>
                <Tooltip title={`Resource ${props.fixedrateservice.id}`}>
                    <RequestQuote />
                </Tooltip>
            </TableCell>
            <TableCell onContextMenu={(e) => handleCellContextMenu(e, props.sub_project.name.toLowerCase())}>
                <Tooltip title={`This is sub project ${props.sub_project.id}`}>
                    <Chip
                        label={props.sub_project.name.toLowerCase()}
                        size='small'
                        variant='outlined'
                        sx={{ bgcolor: props.sub_project_colors[props.sub_project.id], fontWeight: 'bold' }}
                    />
                </Tooltip>
            </TableCell>
            <TableCell onContextMenu={(e) => handleCellContextMenu(e, dayjs(props.fixedrateservice.server_timestamp_created).format('DD/MM/YYYY'))}>
                {dayjs(props.fixedrateservice.server_timestamp_created).format('DD/MM/YYYY')}
            </TableCell>
            <TableCell onContextMenu={(e) => handleCellContextMenu(e, props.fixedrateservice.description || '')}>
                {props.fixedrateservice.description}
            </TableCell>
            <TableCell align='right' onContextMenu={(e) => handleCellContextMenu(e, props.fixedrateservice.quantity.toFixed(2))}>
                {props.fixedrateservice.quantity.toFixed(2)}
            </TableCell>
            <TableCell onContextMenu={(e) => handleCellContextMenu(e, props.fixedrateservice.unit || '')}>
                {props.fixedrateservice.unit}
            </TableCell>
            <TableCell align='right' onContextMenu={(e) => handleCellContextMenu(e, props.fixedrateservice.cost_per_unit.toFixed(2))}>
                {props.fixedrateservice.cost_per_unit.toFixed(2)}
            </TableCell>
            <TableCell align='right' onContextMenu={(e) => handleCellContextMenu(e, props.fixedrateservice.cost.toFixed(2))}>
                {props.fixedrateservice.cost.toFixed(2)}
            </TableCell>
            <TableCell align='right' onContextMenu={(e) => handleCellContextMenu(e, (props.fixedrateservice.cost * 1.15).toFixed(2))}>
                {(props.fixedrateservice.cost * 1.15).toFixed(2)}
            </TableCell>
            <TableCell sx={{ p: 0, m: 0, px: 0.5 }} align='right'>
                {props.remove === true && (
                    is_busy ?
                        <CircularProgress size={'1rem'} />
                        :
                        <IconButton
                            size={'small'}
                            color='error'
                            onClick={() => handleUnassignFromProject(props.fixedrateservice)}
                        >
                            <CloseIcon fontSize='inherit' />
                        </IconButton>
                )
                }
            </TableCell>
        </TableRow>
    );
}